import StepForAuthorization from './StepForAuthorization'

export default StepForAuthorization;